import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ReactNotifications } from 'react-notifications-component'

import Routes from "./routes/routes";

import store from "./store/store";

import "react-notifications-component/dist/theme.css";

function App() {
  return (
    <Provider store={store.store}>
      <PersistGate loading={null} persistor={store.persistor}>
		<ReactNotifications />
        <Routes />
      </PersistGate>
    </Provider>
  );
}

export default App;
